import { AccountBalance, AccountCircle, Check, ExpandLess, ExpandMore, Logout, Queue } from "@mui/icons-material";
import { Divider, Hidden, useMediaQuery } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import { useEffect, useMemo, useState } from "react";

import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import Avatar from "../Avatar";
import Box from "../Box";
import CustomMenuItem from "../DataTable/CustomMenuItem";
import ModalManageOrganization from "../ModalManageOrganization";
import Typography from "../Typography";

import { ICodename } from "../../commons/interfaces";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";
import { useMaterialUIController } from "../context";
import { styleBoxPopper, styleIconButton } from "./styles";

interface Props {
    light?: boolean;
    anchorEl: React.MutableRefObject<HTMLButtonElement | null | undefined>;
    isCorporateMode?: boolean;

    lableOrganization?: string;

    openDropDown: any;
    uncheckedOrganization?: boolean;
    setOpenDropDown: React.Dispatch<React.SetStateAction<any>>;

    pathNameProfile: string;
    onNavigate?: (pathName: string) => void;

    onLogout: () => void;
    onSubmitManageOrganization?: () => void;
    onChangeOrganization?: (orgId: string) => void;

    listItemDropDown?: {
        title: string;
        icon?: JSX.Element;
        onCallBack: () => void;
    }[];

    hidenNameOrganization?: boolean;
    hidenItemDropDown?: {
        itemLogout?: boolean;
        itemProfileInfo?: boolean;
        itemOrganizationActive?: boolean;
        itemManagementOrganization?: boolean;
    };
}

function UserProfileDropdown({
    light,
    anchorEl,
    openDropDown,
    pathNameProfile,
    listItemDropDown,
    hidenItemDropDown,
    lableOrganization,
    hidenNameOrganization,
    uncheckedOrganization,
    isCorporateMode,

    onLogout,
    onNavigate,
    setOpenDropDown,
    onChangeOrganization,
    onSubmitManageOrganization,
}: Props): JSX.Element {
    const [controller] = useMaterialUIController();
    const isMobile = useMediaQuery("(max-width: 768px)");

    const { transparentNavbar, darkMode } = controller;

    const { userInfo } = useCommonComponentContext();
    const Strings = useStrings();

    const [openModalManageOrg, setOpenModalManageOrg] = useState<boolean>(false);
    const [currentOrganizationId, setCurrentOrganizationId] = useState<string>(undefined);

    const avatarUrlProfile = useMemo(() => userInfo?.userProfile?.avatarUrl, [userInfo?.userProfile?.avatarUrl]);

    const fullNameProfile = useMemo(
        () => userInfo?.userProfile?.fullName || userInfo?.userProfile?.userName || "",
        [userInfo?.userProfile?.fullName, userInfo?.userProfile?.userName]
    );

    useEffect(() => {
        setCurrentOrganizationId(userInfo?.userProfile?.organizationId || "0");
    }, [userInfo?.userProfile?.organizationId]);

    const handleCloseMenu = () => setOpenDropDown(false);
    const handleOpenMenu = (event: any) => setOpenDropDown(anchorEl.current);

    const itemCurrentOrg = useMemo(() => {
        const itemTemp = userInfo?.listOrganization?.find((e) => e.code === currentOrganizationId);
        return itemTemp;
    }, [currentOrganizationId, userInfo?.listOrganization]);

    const renderOrganizationActive = () => {
        const listOrgSort = [...(userInfo?.listOrganization || [])].sort((a, b) => (`${a.code}` === currentOrganizationId ? -1 : 1));

        return (
            <>
                {listOrgSort?.length > 0 && <Divider />}
                {listOrgSort?.length > 0 && (
                    <CustomMenuItem
                        key={"list_org"}
                        icon={<AccountBalance fontSize="small" />}
                        title={lableOrganization || Strings.Common.ORGANIZATION}
                        sx={{
                            "&:hover": {
                                cursor: "default",
                                backgroundColor: "#FFFFF",
                            },
                        }}
                    />
                )}
                {listOrgSort?.length > 0 && (
                    <Box overflow={listOrgSort?.length > 5 ? "auto" : "hidden"} height={33 * (listOrgSort?.length > 5 ? 5 : listOrgSort?.length)}>
                        {listOrgSort?.map((item) => (
                            <CustomMenuItem
                                key={item.code}
                                title={item.name}
                                maxWidth={"200px"}
                                style={{ marginBottom: "0px" }}
                                colorText={currentOrganizationId === item.code ? "info" : "dark"}
                                icon={
                                    currentOrganizationId === item.code ? (
                                        <Check color="info" fontSize="small" />
                                    ) : (
                                        <span style={{ padding: "10px" }}></span>
                                    )
                                }
                                onClick={() => {
                                    if (Helpers.isFunction(onChangeOrganization)) {
                                        if (currentOrganizationId === item.code) {
                                            uncheckedOrganization && onChangeOrganization("0");
                                        } else {
                                            onChangeOrganization(item.code as string);
                                        }
                                    }
                                    setOpenDropDown(false);
                                }}
                            />
                        ))}
                    </Box>
                )}
            </>
        );
    };

    const renderDropdown = () => {
        return (
            <Menu
                anchorEl={openDropDown}
                anchorReference={null}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                open={Boolean(openDropDown)}
                onClose={handleCloseMenu}
            >
                <Box sx={styleBoxPopper}>
                    {!hidenItemDropDown?.itemProfileInfo && (
                        <CustomMenuItem
                            key={"acc_info"}
                            title={Strings.Common.ACCOUNT_INFO}
                            icon={<AccountCircle fontSize="small" />}
                            onClick={() => {
                                Helpers.isFunction(onNavigate) && onNavigate(pathNameProfile);
                                setOpenDropDown(false);
                            }}
                        />
                    )}

                    {!hidenItemDropDown?.itemOrganizationActive && renderOrganizationActive()}

                    {listItemDropDown?.map((itemMenu, index) => (
                        <>
                            <Divider />
                            <CustomMenuItem key={index} icon={itemMenu.icon} title={itemMenu.title} onClick={itemMenu.onCallBack} />
                        </>
                    ))}

                    {!hidenItemDropDown?.itemManagementOrganization && <Divider />}
                    {!hidenItemDropDown?.itemManagementOrganization && (
                        <CustomMenuItem
                            key="management_org"
                            icon={<Queue fontSize="small" />}
                            title={Helpers.capitalizeFirstLetter(
                                Strings.format(
                                    Strings.Organization.MANAGEMENT_ORGANIZATIONS,
                                    (lableOrganization || Strings.Common.ORGANIZATION).toLowerCase()
                                )
                            )}
                            onClick={() => {
                                setOpenDropDown(false);
                                setOpenModalManageOrg(true);
                            }}
                        />
                    )}

                    {!hidenItemDropDown?.itemLogout && <Divider />}
                    {!hidenItemDropDown?.itemLogout && (
                        <CustomMenuItem
                            key={"log_out"}
                            title={Strings.Common.LOGOUT}
                            icon={<Logout fontSize="small" />}
                            onClick={() => {
                                onLogout();
                                setOpenDropDown(false);
                            }}
                        />
                    )}
                </Box>
            </Menu>
        );
    };

    return (
        <>
            {isCorporateMode ? (
                <CorporateMode
                    {...{
                        openDropDown,
                        anchorEl,
                        avatarUrlProfile,
                        fullNameProfile,
                        handleOpenMenu,
                        isMobile,
                        itemCurrentOrg,
                        hidenNameOrganization,
                    }}
                />
            ) : (
                <NormalMode
                    {...{
                        openDropDown,
                        anchorEl,
                        avatarUrlProfile,
                        fullNameProfile,
                        handleOpenMenu,
                        isMobile,
                        itemCurrentOrg,
                        hidenNameOrganization,
                    }}
                />
            )}

            {(!hidenItemDropDown?.itemLogout ||
                !hidenItemDropDown?.itemProfileInfo ||
                !hidenItemDropDown?.itemOrganizationActive ||
                !hidenItemDropDown?.itemManagementOrganization) &&
                renderDropdown()}

            {openModalManageOrg && (
                <ModalManageOrganization
                    visibled={openModalManageOrg}
                    lableOrganization={lableOrganization}
                    onClose={() => {
                        setOpenModalManageOrg(false);
                    }}
                    getUserLoginInformation={() => {
                        Helpers.isFunction(onSubmitManageOrganization) && onSubmitManageOrganization();
                    }}
                />
            )}
        </>
    );
}

const NormalMode = ({
    openDropDown,
    light,
    anchorEl,
    hidenNameOrganization,
    handleOpenMenu,
    fullNameProfile,
    avatarUrlProfile,
    isMobile,
    itemCurrentOrg,
}: {
    openDropDown: any;
    handleOpenMenu: (event: any) => void;
    fullNameProfile: string;
    avatarUrlProfile: string;
    isMobile: boolean;
    itemCurrentOrg: ICodename;
    light?: boolean;
    anchorEl: React.MutableRefObject<HTMLButtonElement | null | undefined>;
    hidenNameOrganization?: boolean;
}) => {
    const [controller] = useMaterialUIController();

    const { transparentNavbar, darkMode } = controller;

    const { userInfo } = useCommonComponentContext();
    const Strings = useStrings();

    const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }: { palette: any; functions: any }) => ({
        color: () => {
            let colorValue = light || darkMode ? white.main : dark.main;
            if (transparentNavbar && !light) {
                colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
            }
            return colorValue;
        },
    });

    return (
        <IconButton size="large" disableRipple ref={anchorEl} sx={styleIconButton} onClick={handleOpenMenu}>
            <Avatar sx={iconsStyle} text={fullNameProfile} src={avatarUrlProfile} style={{ border: "1px #c3c3c3 solid" }} />
            {!isMobile && (
                <Hidden only={["sm", "xs"]}>
                    <Box style={{ marginLeft: "8px" }}>
                        <Box display="flex">
                            <Typography
                                variant="h4"
                                sx={{
                                    maxWidth: "220px",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                }}
                            >
                                {fullNameProfile}
                            </Typography>
                        </Box>
                        {!hidenNameOrganization && userInfo?.listOrganization?.length !== 0 && (
                            <Box display="flex">
                                <Typography
                                    variant="button"
                                    sx={{
                                        maxWidth: "220px",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        textDecoration: "underline",
                                        ":hover": { color: "#1A73E8" },
                                    }}
                                >
                                    {itemCurrentOrg?.name || Strings.Common.DO_NOT_CHOOSE}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Hidden>
            )}
        </IconButton>
    );
};

const CorporateMode = ({
    openDropDown,
    light,
    anchorEl,
    hidenNameOrganization,
    handleOpenMenu,
    fullNameProfile,
    avatarUrlProfile,
    isMobile,
    itemCurrentOrg,
}: {
    openDropDown: any;
    handleOpenMenu: (event: any) => void;
    fullNameProfile: string;
    avatarUrlProfile: string;
    isMobile: boolean;
    itemCurrentOrg: ICodename;
    light?: boolean;
    anchorEl: React.MutableRefObject<HTMLButtonElement | null | undefined>;
    hidenNameOrganization?: boolean;
}) => {
    const [controller] = useMaterialUIController();

    const { transparentNavbar, darkMode } = controller;

    const { userInfo } = useCommonComponentContext();
    const Strings = useStrings();

    const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }: { palette: any; functions: any }) => ({
        color: () => {
            let colorValue = light || darkMode ? white.main : dark.main;
            if (transparentNavbar && !light) {
                colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
            }
            return colorValue;
        },
    });
    return (
        <IconButton size="large" disableRipple ref={anchorEl} sx={styleIconButton} onClick={handleOpenMenu}>
            {!isMobile && (
                <Hidden only={["sm", "xs"]}>
                    <Box
                        sx={{
                            mr: 1,
                            textAlign: "right",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "end",
                            justifyContent: "right",
                            gap: 0.5,
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                maxWidth: "220px",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                textAlign: "right",
                                color: "#1C252E",
                                fontSize: "1rem",
                                fontWeight: 600,
                            }}
                        >
                            {fullNameProfile}
                        </Typography>
                        {!hidenNameOrganization && userInfo?.listOrganization?.length !== 0 && (
                            <Typography
                                sx={{
                                    maxWidth: "220px",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    // textDecoration: "underline",
                                    textAlign: "right",
                                    color: "#637381",
                                    fontSize: "0.8125rem",
                                    ":hover": { color: "#1A73E8" },
                                }}
                            >
                                {itemCurrentOrg?.name || Strings.Common.DO_NOT_CHOOSE}
                            </Typography>
                        )}
                    </Box>
                </Hidden>
            )}
            <Avatar sx={iconsStyle} text={fullNameProfile} src={avatarUrlProfile} style={{ border: "1px #c3c3c3 solid", width: 36, height: 36 }} />

            {Boolean(openDropDown) ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
    );
};

export default UserProfileDropdown;
